import React, { useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
	CopyLink,
	CopyTitle,
	InviteLinkContainer,
	InviteLinkTerm,
	InviteLinkTerms,
	InviteLinkTitle,
	ChainIconContainer,
	ChainIcon,
	CreateLinkButton,
	TermsAndConditionsContainer,
	Divider,
	DividerWrapper,
} from "./InviteLink.style";
import { PlusIcon } from "@assets";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";
import { Modal } from "antd";

const InviteLink = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [textToCopy, setTextToCopy] = useState("");

	const userPreferedLanguage = localStorage.getUserPreferedLanguage();
	const { invite_link_rule } = useSelector((state) => state.app.settings);

	const inviteLinkRule =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? invite_link_rule?.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
				? invite_link_rule?.text_mm
				: invite_link_rule?.text_ch;

	const getInviteLink = () => {
		setLoading(true);
		api
			.postReferral()
			.then(({ referral_id }) => {
				const domain = window.location.hostname;
				setLoading(false);
				setTextToCopy(`${domain}/register?referral_id=${referral_id}`);
				setIsOpen(true);
			})
			.catch((errorMsg) => {
				setLoading(false);
				showAlert({
					message: errorMsg,
					isError: true,
				});
			});
	};

	const handleCopyClick = () => {
		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				setIsOpen(false);
				showAlert({
					message: t("common.copied"),
					successCallback: goBack,
				});
			})
			.catch((error) => {
				//create input or text area
				const input = document.createElement('input');
				input.setAttribute('value', textToCopy);
				document.body.appendChild(input);
				input.select();
				const result = document.execCommand('copy');
				document.body.removeChild(input);
				if (result) {
					showAlert({
						message: t("common.copied"),
						successCallback: goBack,
					});
				} else {
					showAlert({
						message: "Failed to copy to clipboard.",
						isError: true,
					});
				}
			});
	};

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.PROFILE}`);
	};

	const showAlert = (data) => {
		dispatch(openAlert(data));
	};

	return (
		<>
			<Topbar title={t("profile.inviteLink")} goBack={goBack} shadow={false} />
			<InviteLinkContainer>
				<ChainIconContainer>
					<ChainIcon />
				</ChainIconContainer>
				<InviteLinkTitle>{t("profile.inviteLinkSubtitle")}</InviteLinkTitle>

				<CreateLinkButton
					language={userPreferedLanguage}
					onClick={getInviteLink}
					loading={loading}
				>
					{t("common.create")}
					<PlusIcon />
				</CreateLinkButton>

				<TermsAndConditionsContainer>
					<InviteLinkTerm>{t("profile.inviteLinkTerms")}</InviteLinkTerm>
					<DividerWrapper>
						<Divider style={{ borderColor: "#D28A28" }} />
					</DividerWrapper>
					<InviteLinkTerms
						dangerouslySetInnerHTML={{ __html: inviteLinkRule }}
					/>
				</TermsAndConditionsContainer>
			</InviteLinkContainer>
			<Modal
				open={isOpen}
				closable={false}
				style={{
					textAlign: "center",
				}}
				centered={true}
				onCancel={() => setIsOpen(false)}
				cancelText={t("common.cancel")}
				onOk={handleCopyClick}
				okText={t("common.copy")}
				width={326}
			>
				<CopyTitle>{t("profile.inviteLinkModalContent")}</CopyTitle>
				<CopyLink>{textToCopy}</CopyLink>
			</Modal>
			<Alert />
		</>
	);
};

export default InviteLink;
